/* ============================================
   CART TOTAL SYNC BFE - TDTP
   ============================================

   Repareert een race in Pipeline waardoor het bedrag op de checkout-knop achter
   kan lopen op de werkelijke winkelwagen.

   Wat er gebeurt: na een toevoeging vuurt het theme twee events af.
   'theme:cart:reload' is synchroon, 'theme:cart:change' wacht eerst op een
   fetch van /cart.js. Wint reload die race, dan hertekent de drawer met de nog
   oude cart-state en blijft de knop op het vorige bedrag staan; het latere
   change-event werkt de state wel bij maar hertekent niets meer.

   Op een collectiepagina komt de volgorde meestal goed uit, in de cart drawer
   vaak niet — daar zie je het bedrag dus blijven hangen.

   Aanpak: na een cartwijziging vergelijken we het getoonde bedrag met het
   werkelijke totaal. Wijkt het af, dan vragen we het theme om nog één keer te
   hertekenen. Bewust niet zelf het bedrag formatteren: er is geen globale
   money-formatter en met meerdere markten en valuta zou dat scheef gaan.

   Versie: 1.0 - 28-07-2026
   ============================================ */

(function () {
  'use strict';

  var SELECTOR = '[data-cart-final]';
  var pending = false;

  // "€9,95 EUR" -> "995". Werkt voor punt- én komma-scheiding, zolang er twee
  // decimalen zijn — wat voor alle markten van deze shop geldt.
  function shownCents(el) {
    var digits = (el.textContent || '').replace(/\D/g, '');
    return digits === '' ? null : parseInt(digits, 10);
  }

  function verify(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var el = document.querySelector(SELECTOR);
    if (!el) return;

    var shown = shownCents(el);
    if (shown === cart.total_price) return;

    // Nog niet gelijk: het theme is mogelijk nog bezig. Eén hertekening vragen.
    if (pending) return;
    pending = true;
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    window.setTimeout(function () {
      pending = false;
    }, 1000);
  }

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    // Twee metingen: direct na het event en nadat het theme z'n hertekening
    // heeft kunnen afronden. De eerste vangt de trage variant, de tweede
    // voorkomt dat we onnodig een extra hertekening aanvragen.
    window.setTimeout(function () {
      verify(cart);
    }, 400);
  });
})();
